import React from "react";
import {List} from "../modules/Products";

export function ProductsListPage() {
  return (
    <List />
  );
}
